import { InjectionToken } from '@angular/core';


/**
 * Token for injecting a configuration object
 * @ignore
 */
export const TswpUiLibraryConfigToken = new InjectionToken('TswpUiLibraryConfig');
